import React, { useState } from "react";

import bg from "../../Images/Group 1171279366 (3).png";
import QuaterlyPlan from "./QuaterlyPlan";
import QuarterlyComparePlan from "./QuaterlyComparePlan";
import MonthlyComparePlan from "./MonthlyComparePlan";
import YearlyComparePlan from "./YearlyComparePlan.jsx";
import MontlyPlan from "./MontlyPlan.jsx";
import YearlyPlan from "./YearlyPlan.jsx";

const cities = [
  {
    name: "Gurgaon",
    prices: {
      Monthly: 3000,
      Quarterly: 9000,
      Yearly: 18000,
    },
  },
  {
    name: "Noida",
    prices: {
      Monthly: 2500,
      Quarterly: 8000,
      Yearly: 16000,
    },
  },
  {
    name: "South Delhi",
    prices: {
      Monthly: 2500,
      Quarterly: 8000,
      Yearly: 16000,
    },
  },
  {
    name: "Kanpur",
    prices: {
      Monthly: 2400,
      Quarterly: 7000,
      Yearly: 15000,
    },
  },
  {
    name: "Lucknow",
    prices: {
      Monthly: 2300,
      Quarterly: 6500,
      Yearly: 14500,
    },
  },
];

const Plans = ({ setSelectedCity }) => {
  const [activeCity, setActiveCity] = useState(cities[0]);
  const [billingCycle, setBillingCycle] = useState("Monthly");

  const [toggle, setToggle] = useState({
    toggle1: true,
    toggle2: false,
    toggle3: false,
  });
  const handleCityChange = (city) => {
    setActiveCity(city);
    setSelectedCity(city?.name);
  };
  const handleBillingChange = (cycle) => {
    setBillingCycle(cycle);
  };
  return (
    <>
      <section className="pricing_plans_section">
        <img className="price_bgimg" src={bg} />
        <h2 className="price_title_win">
          Winners – All-in-One Brokers Portal{" "}
        </h2>
        <p class="feature-text">
          Verified <strong>Property Owners Database</strong> with
          <strong>real-time updates</strong>,
          <strong>locality-wise filtering</strong>, and
          <strong>ready-to-use cold-calling data</strong> — available on
          <strong>Web, iOS, and Android</strong>.
        </p>
        <div className="city-tabs">
          {cities.map((city) => (
            <button
              key={city.name}
              className={`city-tab ${activeCity.name === city.name ? "active" : ""}`}
              onClick={() => handleCityChange(city)}
            >
              {city.name}
            </button>
          ))}
        </div>
        <div className="pricing_plans_div_head_wrapper">
          <div
            className="pricing_plan_head"
            style={{
              cursor: "pointer",
            }}
          >
            {["Monthly", "Quarterly", "Yearly"].map((cycle) => (
              <div
                key={cycle}
                className={
                  billingCycle === cycle
                    ? "montly_head"
                    : "montly_head_not_active"
                }
                onClick={() => handleBillingChange(cycle)}
              >
                {cycle}
              </div>
            ))}
            {/* <div className={toggle.toggle1 ? 'montly_head' : 'montly_head_not_active'} onClick={(()=>setToggle({
                  toggle1:true,

                 }))}>Quarterly</div>
                 <div className={toggle.toggle2 ? 'montly_head' : 'montly_head_not_active'} onClick={(()=>{
                  setToggle({
                    toggle1:false,
                    toggle2:true,
                    toggle3:false,
                  })
                 })}>Montly</div>
                 <div className={toggle.toggle3 ? 'montly_head' : 'montly_head_not_active'} onClick={(()=>{
                  setToggle({
                    toggle1:false,
                    toggle2:false,
                    toggle3:true,
                  })
                 })}>Half-Yearly</div> */}
          </div>
        </div>
        {toggle.toggle1 && (
          <QuaterlyPlan
            city={activeCity.name}
            price={activeCity.prices[billingCycle]}
            cycle={billingCycle}
          />
        )}
        {toggle.toggle1 && <QuarterlyComparePlan />}
        {toggle.toggle2 && <MontlyPlan />}
        {toggle.toggle2 && <MonthlyComparePlan />}
        {toggle.toggle3 && <YearlyPlan />}
        {toggle.toggle3 && <YearlyComparePlan />}
      </section>
    </>
  );
};

export default Plans;
